var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 23c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.01-11C5.981 1 1 5.982 1 12c0 6.007 4.993 11 11 11m-1.219-5.727c-.366 0-.668-.15-.949-.528l-2.707-3.322c-.161-.215-.258-.452-.258-.7a.87.87 0 0 1 .862-.885c.313 0 .55.097.82.453l2.19 2.826 4.604-7.398c.205-.324.485-.496.766-.496.474 0 .916.323.916.83 0 .237-.14.485-.27.712l-5.068 7.98c-.226.356-.539.528-.906.528"
  })));
};
export default SvgOk;